/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.membership.categories.create.controllers', [
  'ui.router',
  'ui.bootstrap',
  'acme.common.service.api',
  'acme.common.service.membership',
  'acme.common.service.calendar',
  'acme.common.service.helpers',
  'acme.common.service.validate',
  'acme.common.factory.notice',
  'acme.view.application.membership.categories.create.mapping.controllers',
  'acme.view.application.membership.categories.create.description.controllers',
  'acme.view.application.membership.categories.create.pricing.controllers'
])

.controller('MembershipCategoriesCreateController', ['$scope', '$state', '$location', '$timeout', '$filter', '$uibModal', 'ApiService', 'MembershipService', 'NoticeFactory', 'CategoryData', 'CalendarService', 'HelpersService', 'ValidateService', function($scope, $state, $location, $timeout, $filter, $uibModal, ApiService, MembershipService, NoticeFactory, CategoryData, CalendarService, HelpersService, ValidateService) {

    $scope.membershipCategoriesCreate = {

      model: {},
      isSaving: false,
      isPublishing: false,
      isSubmitted: false,

      validators: [],

      lastUpdated: false,

      lastPublished: false,

      mode: 'create',

      notice: new NoticeFactory(),

      cap: HelpersService.cap,

      init: function() {
        var title = 'Create Membership Category', saveText = 'Create and Continue';
        ValidateService.errors = [];
        if($state.params.id) {
          this.mode = 'edit';
          title = 'Edit Membership Category';
          saveText = 'Save and Close';
        }

        $scope.$emit('Application::contentTitleChange', {
          title: title,
          buttonRight: {
            label: saveText,
            permissions: ['MEMBERSHIP_CATEGORY_VIEW'],
            action: function() {
              $scope.membershipCategoriesCreate.save({
                name: 'application.membership.categories',
                stateParams: {}
              });
            }
          },
          buttonLeft: {
            label: 'Close',
            action: function() {
              $scope.membershipCategoriesCreate.cancel();
            }
          }

        });

        MembershipService.resetModel();

        if(CategoryData && CategoryData.data && CategoryData.data.success) {
          this.initCategory();
        }

        this.validators = [{
          field: 'membership-categories-edit-header-name',
          len: {
            message: 'Your title must not be empty',
            test: function() {
              return {
                value: $scope.membershipCategoriesCreate.model.name
              };
            }
          }
        }];
        ValidateService.addFieldTests(this.validators);
      },

      initCategory: function() {
        this.success.initCategory(CategoryData);
      },

      isMode: function(mode) {
        return mode === this.mode;
      },

      isReviewState: function(state) {
        return (MembershipService.getReviewState() === state);
      },

      isState: function(state) {
        var r;

        if (this.mode === 'create') {
          r = ($state.current.name.indexOf('application.membership.categories.create.'+state) === 0);
        }else {
          r = ($state.current.name.indexOf('application.membership.categories.edit.'+state) === 0);
        }
        return r;
      },

      getState: function(name) {
        var self = $scope.membershipCategoriesCreate,
          stateName = 'application.membership.categories',
          stateParams = {};

        if (this.mode === 'create') {
          stateName += '.create.'+name;
        }else{
          stateName += '.edit.'+name;
          stateParams.id = $state.params.id;
        }

        self.save({
          name: stateName,
          stateParams: stateParams
        });
      },

      getError: function(field) {
        return ValidateService.getError(field);
      },

      addPublishFieldTests: function() {
        ValidateService.addFieldTests([{
          field: 'membership-categories-edit-header-price-list',
          equal: {
            message: 'You must select a price list for the event',
            test: function() {
              var invalidSave = !MembershipService.hasPrice();
              return [invalidSave, false];
            }
          }
        }]);
      },

      removePublishFieldTests: function() {
        ValidateService.removeFieldTest([{
          field: 'membership-categories-edit-header-price-list',
          equal: {
            message: 'You must select a price list for the event',
            test: function() {
              var invalidSave = !MembershipService.hasPrice();
              return [invalidSave, false];
            }
          }
        }]);
      },

      remove: function() {
        var self = $scope.membershipCategoriesCreate;

        self.showModal = $uibModal.open({
          templateUrl: 'views/application/views/membership/categories/modals/removeCategory.tpl.html',
          size: 'md',
          controller: 'MembershipCategoriesRemoveModalController',
          resolve: {
            currentMembershipCategory: function() {
              return self.model;
            }
          }
        });

        // Invoked when modal completes with close(params)
        self.showModal.result.then(function (name) {
          self.notice.hideSuccessMessages();
          self.notice.hideErrorMessages();

          self.isRemoving = true;

          ApiService.membership.categories.remove(self.model).then(self.success.remove, self.error.remove);
        });
      },

      save: function(state, publish) {
        var self = $scope.membershipCategoriesCreate;
        self.isSaving = true;
        $scope.$broadcast('MembershipCategoriesCreate::Save');

        self.removePublishFieldTests();

        if (publish) {
          self.addPublishFieldTests();
          ValidateService.runFieldTests();
        } else {
          ValidateService.runFieldTests();
        }

        $timeout( function() {

          var membership = MembershipService.getModel();
          if (ValidateService.errors.length === 0) {
            membership.name = self.model.name;
            self.isPublishing = false;

            if (self.mode === 'create') {
              ApiService.membership.categories.create(membership).then(self.success.create, self.error.create);
            } else {

              if (publish) {
                self.isPublishing = true;
                ApiService.membership.categories.publish(membership).then(self.success.update, self.error.update);
              } else {
                ApiService.membership.categories.update(membership).then(self.success.update, self.error.update);
              }

              if (state) {
                ValidateService.clearFieldTests();
                $state.go(state.name, state.stateParams);
              }
            }
          } else {
            self.isSaving = false;
          }
        }, 0);
      },

      cancel: function() {
        ValidateService.clearFieldTests();
        $state.go('application.membership.categories');
      },

      success: {
        initCategory: function(response) {
          var self = $scope.membershipCategoriesCreate;

          MembershipService.setModel(response.data.payload);

          self.model = MembershipService.getModel();
          if (self.mode === 'create' && self.model.id) {
            ValidateService.clearFieldTests();
            $state.go('application.membership.categories.edit.rules', {id: self.model.id});
          }
        },
        update: function(response) {
          var self = $scope.membershipCategoriesCreate;

          self.success.initCategory(response);

          self.lastUpdated = $filter('date')(CalendarService.parseDate(new Date()), HelpersService.dateFormats.shortDateTime);
          if (response.lastPublishedAt) {
            self.lastPublished = $filter('date')(CalendarService.parseDate(response.lastPublishedAt), HelpersService.dateFormats.shortDateTime);
          }

          self.isSaving = false;
          self.isPublishing = false;

        },

        remove: function(response) {
          ValidateService.clearFieldTests();
          $state.go('application.membership.categories');
        },

        create: function(response) {
          var self = $scope.membershipCategoriesCreate;

          self.success.initCategory(response);

          self.lastUpdated = $filter('date')(CalendarService.parseDate(new Date()), HelpersService.dateFormats.shortDateTime);
          if (response.lastPublishedAt) {
            self.lastPublished = $filter('date')(CalendarService.parseDate(response.lastPublishedAt), HelpersService.dateFormats.shortDateTime);
          }
          self.isSaving = false;
          self.isPublishing = false;

        }
      },

      error: {
        init: function(response) {},
        update: function(response) {
          var self = $scope.membershipCategoriesCreate;
          self.notice.showErrorMessages([
            { message: response.data.error }
          ]);
          self.isSaving = false;
          self.isPublishing = false;
        },
        create: function(response) {
          var self = $scope.membershipCategoriesCreate;
          self.notice.showErrorMessages([
            { message: response.data.error }
          ]);
          self.isSaving = false;
          self.isPublishing = false;
        },
        remove: function(response) {
          var self = $scope.membershipCategoriesCreate;
          self.notice.showErrorMessages([
            { message: response.data.error }
          ]);
        }
      }

    };

    $scope.membershipCategoriesCreate.init();

}]);
